import {Component} from 'react';
import styles from './css/FeedbackOptions.module.css';

export class FeedbackOptions extends Component {
  render() {
    return (
      <ul className={styles.feedback_btns}>
        <li><button onClick={this.props.addGood}>Good</button></li>
        <li><button onClick={this.props.addNeutral}>Neutral</button></li>
        <li><button onClick={this.props.addBad}>Bad</button></li>
      </ul>
    );
  }
}